import {
	RECOMMENDER_OPTIONS,
	RecommenderProviderTypeEnum,
	ROUTERS,
} from '@/constant';
import { memo } from 'react';

import { TableWithActions } from '..';
import Button from '../common/button';
import FilterWithViewAll from '../common/filter-with-view-all';
import Modal from '../common/modal';
import { PAGE_TYPE_ENUM_SELECT_RECOMMENDER_MAP } from './select-recommender-modal.config';
import { useLogic } from './select-recommender-modal.logic';
import { IProps } from './select-recommender-modal.type';

const SelectRecommenderModal = (props: IProps) => {
	const { title = '추천자 선택', name, providerTable, ...rest } = props;

	const {
		filterRef,
		initialValues,
		fetching,
		columns,
		dataSource,
		rowSelection,

		fetchData,
		onCheckIfExists,
		isWorkerPublicAdminRole,
		onNavigateRecommender,
	} = useLogic(props);

	return (
		<Modal title={title} {...rest}>
			<div className="flex justify-between">
				<div className="mb-10 flex gap-3">
					<p className="text-[14px] font-bold">
						{PAGE_TYPE_ENUM_SELECT_RECOMMENDER_MAP[providerTable]}
					</p>
					{!!name && <p className="text-[13px] font-medium">{name} </p>}
				</div>
			</div>
			<div className="mb-10 flex items-center gap-5">
				<p className="text-[14px] font-bold">추천자 등록</p>
				{!isWorkerPublicAdminRole && (
					<Button
						onClick={onNavigateRecommender}
						secondary
						name="register"
						className=" !bg-blue11 !text-white rounded-none !border-none"
					>
						추천자 등록
					</Button>
				)}
			</div>

			<p className="text-[14px] font-bold mb-3">{title}</p>
			<div className="mb-5 flex ">
				<FilterWithViewAll
					ref={filterRef}
					initialValues={initialValues}
					rowSelection={rowSelection}
					fetchData={fetchData}
					inputName="searchValue"
					inputClassName="w-[376px]"
					buttonClassName="w-[60px] min-w-0"
					hidePageSize
					isClickSearch
					ignoreCheckAllKeys={['searchType']}
					isShowAutoComplete
					autoCompleteProps={{
						inputClassName: '!w-[375px]',
						containerClassName: 'w-auto',
						options: RECOMMENDER_OPTIONS,
					}}
				>
					<FilterWithViewAll.SelectMasterInfo
						options={RECOMMENDER_OPTIONS}
						name="searchType"
						containerClassName="w-[200px]"
						defaultValue={RecommenderProviderTypeEnum.RECOMMEND_NAME}
					/>
				</FilterWithViewAll>
			</div>

			<TableWithActions
				{...{ fetching, dataSource, columns }}
				rowSelection={{ ...rowSelection, type: 'radio' }}
				rowKey={'id'}
				pagination={false}
				editable
				scroll={{ y: 400 }}
				toDetailPathName={isWorkerPublicAdminRole ? '' : ROUTERS.RM1_03}
				actionHidden
				loading={fetching}
				isSearching={filterRef?.current?.isSearching}
				containerClassName="p-0"
			/>

			<Button
				type="primary"
				className="mt-8 mx-auto block"
				onClick={onCheckIfExists}
				isMainBtn
				// disabled={isEmptyArray(rowSelection.selectedRowKeys)}
			>
				저장
			</Button>
		</Modal>
	);
};

export default memo(SelectRecommenderModal);
